<div>
  <div class="information-title">{{ featureTitle }}</div>
  <p [innerHtml]="featureText"></p>
  <p [innerHTML]="featureWiki"></p>
  <p>
    {{ 'license.information.text' | translate }}
  </p>
  <ecu-button routerLink="/account/licenses">{{ 'licenses.buy-license' | translate }}</ecu-button>
</div>
